export default {
  SET_PLANS(state, plans) {
    state.plans = plans;
  },
  SET_LIMITS_USAGE(state, limitsUsage) {
    state.limitsUsage = limitsUsage;
  },
  SET_PRICE_PREVIEW(state, pricePreview) {
    state.pricePreview = pricePreview;
  },
  SET_SELECTED_PLAN(state, selectedPlan) {
    state.selectedPlan = selectedPlan;
  },
  SET_SELECTED_LOCATIONS_COUNT(state, count) {
    state.selectedLocationsCount = count;
  },
  SET_SELECTED_PERIOD(state, period) {
    state.selectedPeriod = period;
  },
  SET_SELECTED_PAYMENT_METHOD(state, paymentMethod) {
    state.selectedPaymentMethod = paymentMethod;
  },
  SET_INITIAL_CHOSEN_PLAN(state, initialChosenPlan) {
    state.initialChosenPlan = initialChosenPlan;
  },
  SET_TAX_PRICE(state, taxPrice) {
    state.taxPrice = taxPrice;
  },
  SET_PROMOTION_CODES(state, promotionCodes) {
    state.promotionCodes = promotionCodes;
  },
  SET_PROMO_CODE(state, promoCode) {
    state.promoCode = promoCode;
  },
  SET_CURRENCY(state, currency) {
    state.currency = currency;
  },
  SET_PLAN_CHANGE_TYPE(state, planChangeType) {
    state.planChangeType = planChangeType;
  },
  SET_INITIAL_PLAN_INDEX(state, initialPlanIndex) {
    state.initialPlanIndex = initialPlanIndex;
  }
};
